// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamRosterGetBody = {
  teamId: string;
};

export type typeTeamRosterGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    leagueId: string;
    leagueSeasonId?: string | null;
    hasRoster: boolean;
    emptyReason?: string | null;
    playerCount: number;
    groups: {
      groupKey: string;
      label: string;
      players: {
        playerId: string;
        name: string;
        jerseyNumber?: string | null;
        position?: string | null;
        heightLabel?: string | null;
        weightLabel?: string | null;
        age?: number | null;
        college?: string | null;
        experienceLabel?: string | null;
        headshotUrl?: string | null;
      }[];
      isInjuredGroup: boolean;
    }[];
  };
};

export type typeTeamRosterGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamRosterGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamRosterGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamRosterGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamRosterGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamRosterGetBody);
  }

  return async function postTeamRosterGet(
    payload: typeTeamRosterGetBody,
  ): Promise<typeTeamRosterGetOutput200 | typeTeamRosterGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamRosterGet" failed before calling the network. #5335385385bb`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5335385385bb" },
        },
        data: null,
      } as typeTeamRosterGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/roster-get`,
      httpMethod: "POST",
      options,
    })) as typeTeamRosterGetOutput200 | typeTeamRosterGetOutput400;
  };
}
